import BaseControlView from 'BaseControlView';
import template from 'mobile/control-section.ejs';
import MobileControlAfterRender from "./MobileControlAfterRender";
import restService from 'RestService.js';
import util from 'util/Util.js';
import constants from 'Constants.js';
import themeService from 'ThemeService.js';
import mobileAdjustment from "./GeneralMobileAdjustments";

class SectionControlView extends BaseControlView {

    initialize( opts ) {
        super.initialize( opts );
        this.template = template;
        return this;
    }

    adjustPictureSettings() {
        let assetId = this.model.get('backgroundImageAssetId');
        let styleTag = '';
        if (typeof assetId !== 'undefined' && assetId !== '') {
            if (assetId === '~groupBgImage' && themeService.resolve('~groupBgImage') !== 'null') {
                assetId = themeService.resolve('~groupBgImage');
            }

            let bstylePictureAlign = this.model.get('backgroundImageStyle');
            const imgUrl = !util.isEmpty(assetId) ? restService.getAssetURL(assetId) : '';
            if (typeof bstylePictureAlign === 'undefined' || bstylePictureAlign === '') {
                bstylePictureAlign = 'center'; //default value
                this.model.set('backgroundImageStyle', 'center', constants.MODEL_SILENT);
            }
            switch (bstylePictureAlign) {
                case 'center':
                    styleTag = imgUrl ? "background-image: url('" + imgUrl + "'); background-repeat: no-repeat; background-position: center;" : '';
                    break;
                case 'stretch':
                    styleTag =  imgUrl ? "background-size: 100% 100%; background-image: url('" + imgUrl + "'); background-repeat: no-repeat;": '';
                    break;
                case 'tile':
                    styleTag =  imgUrl ? "background-image: url('" + imgUrl + "'); background-repeat: repeat;": '';
                    break;
            }
        }

        this.model.set('pictureStyle', styleTag, constants.MODEL_SILENT);
    }

    controlsRender() {
        const mobileObjects = this.model.get('mobileObjects');
    
        if (mobileObjects.size) {
            const roots = [];
            const children = [];
    
            mobileObjects.forEach(obj => {
                if (obj.groupId) {
                    children.push(obj);
                } else {
                    roots.push(obj);
                }
            });
    
            //Render Roots First
            roots.sort((a, b) => a.order - b.order);
            roots.forEach(root => {
                MobileControlAfterRender.sendToRender(this.model.get('id'), root);
            });
    
            // Render Children Second
            children.sort((a, b) => {
                return a.order - b.order;
            });
    
            children.forEach(child => {
                MobileControlAfterRender.sendToRender(this.model.get('id'), child);
            });
        }
    
        mobileAdjustment.setContainerMargins(this, $(`#${this.model.get('id')}`));
    }

}

export default SectionControlView;